export { RelatedCompany } from './RelatedCompany'
